import { useCachedSsrRef } from "./serverCache.mjs";
import { useSetLocaleToCacheParams } from "./i18n.mjs";
import { StoreConfigDocument } from "../graphql/Config.mjs";
import { CountryCodeEnum } from "../graphql/graphql-types.gen.mjs";
import { CONFIG_STORE_COUNTRY, CONFIG_STORE_CURRENCY } from "../utils/provides.mjs";
import { mapProductListing } from "../../runtime/composables/products/products";
import { computed, provide, ref } from "vue";
import { useQuery } from "villus";
import { useAsyncData } from "#app";
const DEFAULT_STORE_PICKUP = false;
export function useStoreConfig() {
  const { cacheParam } = useSetLocaleToCacheParams();
  const state = useCachedSsrRef(cacheParam("store-config"), {
    currencyCode: null,
    defaultTitle: null,
    defaultDescription: null,
    defaultKeywords: null,
    title_prefix: null,
    title_suffix: null,
    initialized: false,
    bestSellers: [],
    limited_qty_threshold: null,
    enableStorePickup: DEFAULT_STORE_PICKUP
  });
  const { data, error, execute } = useQuery({
    query: StoreConfigDocument,
    fetchOnMount: false
  });
  useAsyncData(async () => {
    if (state.value.initialized) {
      return;
    }
    await execute();
    if (error.value) {
      throw new Error(error.value.message);
    }
    state.value = {
      currencyCode: data.value?.storeConfig?.base_currency_code,
      defaultTitle: data.value?.storeConfig?.default_title,
      defaultDescription: data.value?.storeConfig?.default_description,
      defaultKeywords: data.value?.storeConfig?.default_keywords,
      title_prefix: data.value?.storeConfig?.title_prefix,
      title_suffix: data.value?.storeConfig?.title_suffix,
      initialized: true,
      limited_qty_threshold: data.value?.storeConfig?.limited_qty_threshold,
      bestSellers: data.value?.storeConfig?.bestsellers?.items?.map(
        mapProductListing
      ) || [],
      enableStorePickup: DEFAULT_STORE_PICKUP
    };
  });
  const refs = {
    currencyCode: computed(() => state.value?.currencyCode),
    defaultTitle: computed(() => state.value?.defaultTitle),
    defaultDescription: computed(() => state.value?.defaultDescription),
    defaultKeywords: computed(() => state.value?.defaultKeywords),
    title_prefix: computed(() => state.value?.title_prefix),
    title_suffix: computed(() => state.value?.title_suffix),
    initialized: true,
    bestSellers: computed(() => state.value?.bestSellers),
    limited_qty_threshold: computed(() => state.value?.limited_qty_threshold),
    enableStorePickup: computed(() => state.value?.enableStorePickup)
  };
  provide(CONFIG_STORE_CURRENCY, ref(refs.currencyCode.value || "EGP"));
  provide(CONFIG_STORE_COUNTRY, CountryCodeEnum.Eg);
  return {
    ...refs
  };
}
